import React, { Component } from "react"
import PropTypes from "prop-types"
import MetaTags from 'react-meta-tags';
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import * as moment from 'moment';
import { withTranslation } from "react-i18next"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getAllProjectAction, deleteProject, getSearchAllProject, updateProjectStatus  } from "../../../store/projects/actions"
import axios from "axios"
import DeleteModal from "../../../components/Common/DeleteModal";
import Switch from "react-switch"
import ProjectChart from "./chart/project-dashboard";
import ProjectMenu from "./menu/all-project"
import {
  Col,
  Container,
  Row,
  Table,
   Card,
  CardBody,
  Label,
  Input,
    FormGroup,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
    CardFooter,
    CardTitle,
    Form,
    CardHeader
} from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { map } from "lodash"
import Moment from 'react-moment';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import RsCard from "components/Rscards/Rscard";
import RSBarChart from "components/charts/RSBarChart";
import RsAdNew from "components/buttons/Adnew";
import RsLink from "components/buttons/rsLink";
import { API_URL } from "helpers/app_url";

class ProjectCompare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectData:[],
      selectedProjects: {
        project1: "0",
        project2: "0",
        project3: "0",
        project4: "0",
        project5: "0",
      },
    }
   
    
  }
  filterProjectOptions = (currentKey) => {
    const { selectedProjects } = this.state;
    const { projects } = this.props;
    const selectedIds = Object.keys(selectedProjects)
      .filter((key) => key !== currentKey)
      .map((key) => selectedProjects[key]);
  
    return projects.filter((project) => !selectedIds.includes(project.projectId));
  };

  handleProjectChange = (projectKey, selectedValue) => {
    const { selectedProjects } = this.state;

    if (Object.values(selectedProjects).includes(selectedValue)) {
      alert("This project is already selected. Please choose another.");
      return;
    }

    this.setState(
      (prevState) => ({
        selectedProjects: {
          ...prevState.selectedProjects,
          [projectKey]: selectedValue,
        },
      }),
      this.submitToAPI 
    );
  };

  submitToAPI = () => {
    const { selectedProjects } = this.state;
    const projectIds = Object.values(selectedProjects).filter((id) => id !== "0");
  
    const payload = {
      brokerId: parseInt(localStorage.getItem("brokerId")) || 0, 
      projectIds: projectIds, 
      isActive: 1,
    };
  
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    if (!token) {
      console.error("Authorization token missing.");
      return;
    }
  
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  
    axios
      .post(`${API_URL}BrokerProjectExt/comparefulldetailforagent`, payload, { headers })
      .then((response) => {
        
        this.setState({ projectData: response.data });
      })
      .catch((error) => {
        console.error("API Error:", error.response?.data || error.message);
      });
  };
  
  
  componentDidMount() { 
    const { onGetAllProject} = this.props;
    onGetAllProject(localStorage.getItem('userId'),localStorage.getItem('brokerId'));
  }
 
 
  render() {
    const userModule = localStorage.getItem('userModule');
    const { projects } = this.props;
    const { selectedProjects } = this.state;
    
    return (
      <React.Fragment>
           {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
          
       
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Projects | Realty Space</title>
          </MetaTags>
          <Container fluid className="">
            {/* Render Breadcrumbs */}
           
           <Row className="project-header mb20">
              <Col lg="6">
              <Breadcrumbs
              title={this.props.t("Project")}
              breadcrumbItem={this.props.t("Compare")}
            />
              </Col>
	
             <Col lg="6">
             
             </Col>
           </Row>
          <Card className="card-without-border">
              <CardHeader className="">
            <ProjectMenu />
            </CardHeader>
            </Card>
            
            <Card className="compare-card">
                <CardBody>
                    <Row>
                        <Col sm="2">
                            <h4>Compare Project</h4>
                        </Col>
                        <Col sm="2">
  <h4>Project 1</h4>
  <select
    name="project1"
    className="form-control"
    value={this.state.selectedProjects.project1 || "0"}
    onChange={(e) => this.handleProjectChange("project1", e.target.value)}
  >
    <option value="0">Select Project</option>
    {this.filterProjectOptions("project1").map((project) => (
      <option value={project.projectId} key={project.projectId}>
        {project.projectName}
      </option>
    ))}
  </select>
</Col>

<Col sm="2">
  <h4>Project 2</h4>
  <select
    name="project2"
    className="form-control"
    value={this.state.selectedProjects.project2 || "0"}
    onChange={(e) => this.handleProjectChange("project2", e.target.value)}
    disabled={this.state.selectedProjects.project1 === "0"} 
  >
    <option value="0">Select Project</option>
    {this.filterProjectOptions("project2").map((project) => (
      <option value={project.projectId} key={project.projectId}>
        {project.projectName}
      </option>
    ))}
  </select>
</Col>

<Col sm="2">
  <h4>Project 3</h4>
  <select
    name="project3"
    className="form-control"
    value={this.state.selectedProjects.project3 || "0"}
    onChange={(e) => this.handleProjectChange("project3", e.target.value)}
    disabled={this.state.selectedProjects.project2 === "0"} 
  >
    <option value="0">Select Project</option>
    {this.filterProjectOptions("project3").map((project) => (
      <option value={project.projectId} key={project.projectId}>
        {project.projectName}
      </option>
    ))}
  </select>
</Col>

<Col sm="2">
  <h4>Project 4</h4>
  <select
    name="project4"
    className="form-control"
    value={this.state.selectedProjects.project4 || "0"}
    onChange={(e) => this.handleProjectChange("project4", e.target.value)}
    disabled={this.state.selectedProjects.project3 === "0"} 
  >
    <option value="0">Select Project</option>
    {this.filterProjectOptions("project4").map((project) => (
      <option value={project.projectId} key={project.projectId}>
        {project.projectName}
      </option>
    ))}
  </select>
</Col>

<Col sm="2">
  <h4>Project 5</h4>
  <select
    name="project5"
    className="form-control"
    value={this.state.selectedProjects.project5 || "0"}
    onChange={(e) => this.handleProjectChange("project5", e.target.value)}
    disabled={this.state.selectedProjects.project4 === "0"}
  >
    <option value="0">Select Project</option>
    {this.filterProjectOptions("project5").map((project) => (
      <option value={project.projectId} key={project.projectId}>
        {project.projectName}
      </option>
    ))}
  </select>
</Col>

                       
                    </Row>
                    {this.state.projectData.length > 0 ? (
                      <>
                    <hr />
                    <Row>
                        <Col sm="2">
                            <h3 style={{fontSize:14}}></h3>
                        </Col>
                        {this.state.projectData.map((project, index) => (
                      <Col sm="2" key={index}>
                        {project.projectLogoLink	 ? (
                          <img src={project.projectLogoLink} alt="Project Logo" style={{ width: "80px"}} />
                        ) : (
                          ''
                        )}
                      </Col>
                    ))}
                    </Row>
                    <hr />
                    <Row>
                        <Col sm="2">
                            <h3 style={{fontSize:14, fontWeight:'bold'}}>Occupancy year</h3>
                        </Col>
                        {this.state.projectData.map((project, index) => (
                      <Col sm="2" key={index}>
                        <h3>{project.estimatedOccupancy || "-"}</h3>
                      </Col>
                    ))}
                    </Row>
                    <hr />
                    <Row>
                        <Col sm="2">
                            <h3 style={{fontSize:14, fontWeight:'bold'}}>City</h3>
                        </Col>
                        {this.state.projectData.map((project, index) => (
                      <Col sm="2" key={index}>
                        <h3>{project.city || "-"}</h3>
                      </Col>
                    ))}
                    </Row>
                    <hr />
                    <Row>
                        <Col sm="2">
                            <h3 style={{fontSize:14, fontWeight:'bold'}}>Unit costs starting from</h3>
                        </Col>
                        {this.state.projectData.map((project, index) => (
                      <Col sm="2" key={index}>
                        <h3>{project.costPerSqFt ? '$'+project.costPerSqFt : "-"}</h3>
                      </Col>
                    ))}
                    </Row>
                    <hr />
                    <Row>
                        <Col sm="2">
                            <h3 style={{fontSize:14, fontWeight:'bold'}}>Total marketing</h3>
                        </Col>
                         {this.state.projectData.map((project, index) => (
                        <Col sm="2" key={index}>
                          <h3>{project.totalMarketing ? '$'+project.totalMarketing : "-"}</h3>
                        </Col>
                      ))}
                      
                    </Row>
                    <hr />
                    <Row>
                        <Col sm="2">
                            <h3 style={{fontSize:14, fontWeight:'bold'}}># Clients</h3>
                        </Col>
                       {this.state.projectData.map((project, index) => (
                        <Col sm="2" key={index}>
                          <h3>{project.noOfClients ? project.noOfClients : "-"}</h3>
                        </Col>
                      ))}
                        
                    </Row>
                    <hr />
                    <Row>
                        <Col sm="2">
                            <h3 style={{fontSize:14, fontWeight:'bold'}}>Cost/client</h3>
                        </Col>
                         {this.state.projectData.map((project, index) => (
                        <Col sm="2" key={index}>
                          <h3>{project.costPerClient ? '$'+project.costPerClient : "-"}</h3>
                        </Col>
                      ))}
                      
                    </Row>
                    <hr />
                    </>
                  ) : (
                    <h3>No Data Available</h3>
                  )}
              </CardBody>
              </Card>
            

    
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

ProjectCompare.propTypes = {
  
  className: PropTypes.any,
  t: PropTypes.any,
  projects:PropTypes.array,
  onGetAllProject:PropTypes.func,
  onDeleteProject: PropTypes.func,
  loading:PropTypes.object,
  setProjectSearchComplitionYear:PropTypes.func,
  setProjectSearchCity:PropTypes.func,
  onGetSearchAllProject:PropTypes.func,
  onUpdateStatus:PropTypes.func
}

const mapStateToProps = ({ Project }) => ({
  projects:Project.projects,
  loading:Project.loading
})

const mapDispatchToProps = dispatch => ({
  onGetAllProject:(agentId, brokerId) => dispatch(getAllProjectAction(agentId, brokerId)),
  onDeleteProject: (id) => dispatch(deleteProject(id)),
  onGetSearchAllProject:(data) => dispatch(getSearchAllProject(data)),
  onUpdateStatus:(data) => dispatch(updateProjectStatus(data))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(ProjectCompare)))